import { render, staticRenderFns } from "./inquiry_trouble.vue?vue&type=template&id=53db0cf1&"
import script from "./inquiry_trouble.vue?vue&type=script&lang=js&"
export * from "./inquiry_trouble.vue?vue&type=script&lang=js&"
import style0 from "./inquiry_trouble.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports